'use strict';

import { IStyleDto_Props } from './StyleDto.if';
import IStyleDto from './StyleDto.if';
import StyleDto from './StyleDto';
import IFontSizeUnitDto from './FontSizeUnitDto.if';
import FontSizeUnitDto from './FontSizeUnitDto';
import IMediumDto from './MediumDto.if';
import MediumDto from './MediumDto';
import IBackgroundModeDto from './BackgroundModeDto.if';
import BackgroundMode from './BackgroundModeDto';
import IFontFamilyDto from './FontFamilyDto.if';
import FontFamilyDto from './FontFamilyDto';
import IFontStyleDto from './FontStyleDto.if';
import FontStyleDto from './FontStyleDto';
import IFontAlignmentDto from './FontAlignmentDto.if';
import FontAlignmentDto from './FontAlignmentDto';
import ISiteDto from './SiteDto.if';
import SiteDto from './SiteDto';
import { IModelSource } from '../interface/db';
import DBUtil from '../private/db.util';

export interface IStyleDto_Linkables {
    parent: (db: IModelSource) => Promise<IStyleDto>;
    site: (db: IModelSource) => Promise<ISiteDto>;
    foregroundImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    backgroundImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    menuImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    backgroundMode: (db: IModelSource) => Promise<IBackgroundModeDto>;
    primaryFontFamily: (db: IModelSource) => Promise<IFontFamilyDto>;
    primaryFontStyle: (db: IModelSource) => Promise<IFontStyleDto>;
    primaryFontSizeUnit: (db: IModelSource) => Promise<IFontSizeUnitDto>;
    primaryFontAlignment: (db: IModelSource) => Promise<IFontAlignmentDto>;
    secondaryFontFamily: (db: IModelSource) => Promise<IFontFamilyDto>;
    secondaryFontStyle: (db: IModelSource) => Promise<IFontStyleDto>;
    secondaryFontSizeUnit: (db: IModelSource) => Promise<IFontSizeUnitDto>;
    secondaryFontAlignment: (db: IModelSource) => Promise<IFontAlignmentDto>;
    tertiaryFontFamily: (db: IModelSource) => Promise<IFontFamilyDto>;
    tertiaryFontStyle: (db: IModelSource) => Promise<IFontStyleDto>;
    tertiaryFontSizeUnit: (db: IModelSource) => Promise<IFontSizeUnitDto>;
    tertiaryFontAlignment: (db: IModelSource) => Promise<IFontAlignmentDto>;
}

function _parent(this: Partial<IStyleDto_Props>, db: IModelSource): Promise<IStyleDto> {
    return this.parentId
        ? DBUtil.loadStyleId<IStyleDto>(db, this.parentId, StyleDto)
        : Promise.reject('Missing field style.parentId');
}

function _site(this: Partial<IStyleDto_Props>, db: IModelSource): Promise<ISiteDto> {
    return this.siteId
        ? DBUtil.loadSiteId<ISiteDto>(db, this.siteId, SiteDto)
        : Promise.reject('Missing field style.siteId');
}

function _foregroundImageMedium(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.foregroundImageMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.foregroundImageMediumId, MediumDto)
        : Promise.reject('Missing field style.foregroundImageMediumId');
}

function _backgroundImageMedium(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.backgroundImageMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.backgroundImageMediumId, MediumDto)
        : Promise.reject('Missing field style.backgroundImageMediumId');
}

function _menuImageMedium(this: Partial<IStyleDto_Props>, db: IModelSource): Promise<IMediumDto> {
    return this.menuImageMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.menuImageMediumId, MediumDto)
        : Promise.reject('Missing field style.menuImageMediumId');
}

function _backgroundMode(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IBackgroundModeDto> {
    return this.backgroundModeId
        ? DBUtil.loadBackgroundModeId<IBackgroundModeDto>(db, this.backgroundModeId, BackgroundMode)
        : Promise.reject('Missing field style.backgroundModeId');
}

function _primaryFontFamily(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontFamilyDto> {
    return this.primaryFontFamilyId
        ? DBUtil.loadFontFamilyId<IFontFamilyDto>(db, this.primaryFontFamilyId, FontFamilyDto)
        : Promise.reject('Missing field style.primaryFontFamilyId');
}

function _primaryFontStyle(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontStyleDto> {
    return this.primaryFontStyleId
        ? DBUtil.loadFontStyleId<IFontStyleDto>(db, this.primaryFontStyleId, FontStyleDto)
        : Promise.reject('Missing field style.primaryFontStyleId');
}

function _primaryFontSizeUnit(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontSizeUnitDto> {
    return this.primaryFontSizeUnitId
        ? DBUtil.loadFontSizeUnitId<IFontSizeUnitDto>(
              db,
              this.primaryFontSizeUnitId,
              FontSizeUnitDto,
          )
        : Promise.reject('Missing field style.primaryFontSizeUnitId');
}

function _primaryFontAlignment(
    this: IStyleDto_Props,
    db: IModelSource,
): Promise<IFontAlignmentDto> {
    return this.primaryFontAlignmentId
        ? DBUtil.loadFontAlignmentId<IFontAlignmentDto>(
              db,
              this.primaryFontAlignmentId,
              FontAlignmentDto,
          )
        : Promise.reject('Missing field style.primaryFontAlignmentId');
}

function _secondaryFontFamily(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontFamilyDto> {
    return this.secondaryFontFamilyId
        ? DBUtil.loadFontFamilyId<IFontFamilyDto>(db, this.secondaryFontFamilyId, FontFamilyDto)
        : Promise.reject('Missing field style.secondaryFontFamilyId');
}

function _secondaryFontStyle(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontStyleDto> {
    return this.secondaryFontStyleId
        ? DBUtil.loadFontStyleId<IFontStyleDto>(db, this.secondaryFontStyleId, FontStyleDto)
        : Promise.reject('Missing field style.secondaryFontStyleId');
}

function _secondaryFontSizeUnit(
    this: IStyleDto_Props,
    db: IModelSource,
): Promise<IFontSizeUnitDto> {
    return this.secondaryFontSizeUnitId
        ? DBUtil.loadFontSizeUnitId<IFontSizeUnitDto>(
              db,
              this.secondaryFontSizeUnitId,
              FontSizeUnitDto,
          )
        : Promise.reject('Missing field style.secondaryFontSizeUnitId');
}

function _secondaryFontAlignment(
    this: IStyleDto_Props,
    db: IModelSource,
): Promise<IFontAlignmentDto> {
    return this.secondaryFontAlignmentId
        ? DBUtil.loadFontAlignmentId<IFontAlignmentDto>(
              db,
              this.secondaryFontAlignmentId,
              FontAlignmentDto,
          )
        : Promise.reject('Missing field style.secondaryFontAlignmentId');
}

function _tertiaryFontFamily(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontFamilyDto> {
    return this.tertiaryFontFamilyId
        ? DBUtil.loadFontFamilyId<IFontFamilyDto>(db, this.tertiaryFontFamilyId, FontFamilyDto)
        : Promise.reject('Missing field style.tertiaryFontFamilyId');
}

function _tertiaryFontStyle(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontStyleDto> {
    return this.tertiaryFontStyleId
        ? DBUtil.loadFontStyleId<IFontStyleDto>(db, this.tertiaryFontStyleId, FontStyleDto)
        : Promise.reject('Missing field style.tertiaryFontStyleId');
}

function _tertiaryFontSizeUnit(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontSizeUnitDto> {
    return this.tertiaryFontSizeUnitId
        ? DBUtil.loadFontSizeUnitId<IFontSizeUnitDto>(
              db,
              this.tertiaryFontSizeUnitId,
              FontSizeUnitDto,
          )
        : Promise.reject('Missing field style.tertiaryFontSizeUnitId');
}

function _tertiaryFontAlignment(
    this: IStyleDto_Props,
    db: IModelSource,
): Promise<IFontAlignmentDto> {
    return this.tertiaryFontAlignmentId
        ? DBUtil.loadFontAlignmentId<IFontAlignmentDto>(
              db,
              this.tertiaryFontAlignmentId,
              FontAlignmentDto,
          )
        : Promise.reject('Missing field style.tertiaryFontAlignmentId');
}

/** 
 * @description all custom properties for
   StyleDto & methods to link against other entities
*/
function linkables(model: Partial<IStyleDto_Props>): IStyleDto_Linkables {
    return {
        parent: _parent.bind(model),
        site: _site.bind(model),
        foregroundImageMedium: _foregroundImageMedium.bind(model),
        backgroundImageMedium: _backgroundImageMedium.bind(model),
        menuImageMedium: _menuImageMedium.bind(model),
        backgroundMode: _backgroundMode.bind(model),
        primaryFontFamily: _primaryFontFamily.bind(model),
        primaryFontStyle: _primaryFontStyle.bind(model),
        primaryFontSizeUnit: _primaryFontSizeUnit.bind(model),
        primaryFontAlignment: _primaryFontAlignment.bind(model),
        secondaryFontFamily: _secondaryFontFamily.bind(model),
        secondaryFontStyle: _secondaryFontStyle.bind(model),
        secondaryFontSizeUnit: _secondaryFontSizeUnit.bind(model),
        secondaryFontAlignment: _secondaryFontAlignment.bind(model),
        tertiaryFontFamily: _tertiaryFontFamily.bind(model),
        tertiaryFontStyle: _tertiaryFontStyle.bind(model),
        tertiaryFontSizeUnit: _tertiaryFontSizeUnit.bind(model),
        tertiaryFontAlignment: _tertiaryFontAlignment.bind(model),
    };
}

export default linkables;
